<template>
  <div class="mt-4 legal-entity">
    <v-card class="permissions-cartable pa-4 " color="gray10" flat>
      <v-row justify="space-between " align="center" class="title">
        <v-col class="px-4 py-0">
          <v-icon>$editList</v-icon>
          <span class="mb-0 font-Medium-14 gray1--text">
            {{ $t("corporateAccount.permissionsCartable.licensesCartable") }}
          </span>
        </v-col>
        <v-col cols="auto" class="py-0 px-4">
          <router-link
            class="primary--text"
            :to="
              `/history/transaction/withdrawals?${
                tab === 0 ? 'IRR' : 'cryptoCurrency'
              }`
            "
          >
            {{ $t("shared.seeMore") }}
            <!--              <v-icon-->
            <!--                size="20"-->
            <!--                class=""-->
            <!--                clr="var(--v-gray1-base)"-->
            <!--                :class="{ 'transfor-x': !$vuetify.rtl }"-->
            <!--              >-->
            <!--                $vuetify.CustomIcons.arrow-->
            <!--              </v-icon>-->
          </router-link>
        </v-col>
      </v-row>

      <v-tabs
        background-color="transparent"
        class="button-tabs mt-4"
        show-arrows
        v-model="tab"
        @change="changeTabHandler"
      >
        <v-tab v-for="(item, index) in tabs" :key="index" class="button-tab">
          {{ item.tooltip }}
        </v-tab>
      </v-tabs>
      <v-skeleton-loader
        type="list-item@5"
        height="auto"
        :loading="isLoading"
        boilerplate
        class="mt-10"
      >
        <v-row
          justify="center"
          align="center"
          class="no-message"
          v-if="data.length <= 0"
        >
          <v-col class="py-0 px-4 text-center">
            <p class="font-Regular-12 no-message-text mb-0 mt-2">
              {{ $t("corporateAccount.permissionsCartable.noWithdrawalFound") }}
            </p>
          </v-col>
        </v-row>

        <div v-else>
          <v-card
            v-for="(item, index) in data"
            :key="index"
            :to="
              `/legal-entity/submit-order/${
                item.reference_number
              }/withdrawal/crypto?category=${
                item.currency_iso === 'IRR' ? 'IRR' : 'cryptoCurrency'
              }`
            "
            class="card pa-4 mt-3"
            color="gray8"
            flat
          >
            <div class="d-flex align-center justify-space-between">
              <span
                >{{ $t("corporateAccount.permissionsCartable.withdrawal") }}
                {{ item.currency_iso }}</span
              >
              <span>{{ $thousandMask(item.currency_amount) }}</span>
            </div>
            <div
              class="d-flex flex-column flex-md-row align-center justify-space-between mt-2"
            >
              <div
                class="d-flex align-md-center  flex-column flex-md-row  font-Regular-14 gray2--text w-100"
              >
                <span>{{ item.created_at | formatDate }}</span>
                <span class="ms-md-4"
                  >{{ $t("corporateAccount.permissionsCartable.requester") }} :
                  {{ item.creator_user }}</span
                >
              </div>
              <div class="d-flex align-center justify-end  mt-4 mt-md-0 w-100">
                <div class="status-in-table me-10" style="width: max-content">
                  <span
                    class="font-Regular-12"
                    :class="{
                      'info-status': item.status.value === 'CREATED',
                      'success-status': item.status.value === 'PROCESSING',
                      'error-status': item.status.value === 'CANCELED'
                    }"
                  >
                    {{ item.status.locale }}
                  </span>
                </div>
                <v-icon
                  :class="{ 'transfor-x': !$vuetify.rtl }"
                  clr="var(--v-gray1-base)"
                >
                  $arrowLeft
                </v-icon>
              </div>
            </div>
          </v-card>
        </div>
      </v-skeleton-loader>
    </v-card>
  </div>
</template>

<script>
import legalService from "@/services/modules/legalService";
import $thousandMask from "@/mixins/thousandMask";
export default {
  mixins: [$thousandMask],
  data() {
    return {
      tabs: [
        {
          tooltip: this.$t(
            "corporateAccount.permissionsCartable.rialWithdrawal"
          )
        },
        {
          tooltip: this.$t(
            "corporateAccount.permissionsCartable.cryptoWithdrawal"
          )
        }
      ],
      tab: 0,
      data: null,
      isLoading: false
    };
  },
  mounted() {
    this.fetchNeedAcceptance();
  },
  methods: {
    fetchNeedAcceptance() {
      this.isLoading = true;
      legalService
        .needAcceptance({
          per_page: 5,
          currency_type: this.tab === 0 ? "rial" : "crypto"
        })
        .then(res => {
          this.data = res.data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changeTabHandler() {
      this.fetchNeedAcceptance();
    }
  }
};
</script>

<style lang="scss">
.permissions-cartable {
  overflow-y: scroll;
  .no-message {
    height: 275px;
    &-text {
      color: #bbb;
    }
  }
  .withdraw-row {
    background-color: var(--v-lightest-base);
    border-radius: 12px;
  }
}

.button-tabs {
  .v-tabs-slider-wrapper {
    display: none !important;
  }
  .button-tab {
    background-color: var(--v-gray9-base);
    border-radius: 8px;
    margin: 0 4px;
    min-width: 100px;
    font-size: 16px;
    text-transform: none;
  }

  .button-tab::before {
    display: none;
  }

  .button-tab.v-tab--active {
    background-color: var(--v-primary-base) !important;
    color: white;
  }
  .v-tabs-slider {
    display: none;
  }
}
</style>
